export const innerLinks = {
  "FAQs": {
    "label":{
        "EN": 'FAQs',
        "AR": 'الأسئلة الشائعة'
    },
    "Staging": {
      "EN": "https://slstage.sec.se.com.sa/en/Support/FAQs/FAQs/Customer-Service",
      "AR": "https://slstage.sec.se.com.sa/ar-SA/support/faqs/faqs/customer-service"
    },
    "Production": {
      "EN": "https://www.se.com.sa/en/Support/FAQs/FAQs/Customer-Service",
      "AR": "https://www.se.com.sa/ar-SA/support/faqs/faqs/customer-service"
    }
  },
  "Request": {
    "label":{
        "EN": 'View the request',
        "AR": 'الاطلاع على الطلب'
    },
    "Staging": {
      "EN": "https://slstage.sec.se.com.sa/en/eservices/trackrequest",
      "AR": "https://slstage.sec.se.com.sa/ar-SA/EServices/trackrequest"
    },
    "Production": {
      "EN": "https://www.se.com.sa/en/EServices/trackrequest",
      "AR": "https://www.se.com.sa/EServices/trackrequest"
    }
  }
};